import { type SupportedLanguage, SupportedLanguages } from '@centric-os/platform/i18n';
import { useAuthStore } from '@centric-os/stores';
import { PermissionScope } from '@centric-os/types';
import { defineStore, type StateTree } from 'pinia';

interface State extends StateTree {
  reportURL: string;
}

export enum LookerLocales {
  FRENCH = 'fr_CA',
  ENGLISH = 'en',
}

export type LookerLocale = `${LookerLocales}`;

// https://cloud.google.com/looker/docs/supported-user-interface-languages
export const SUPPORTED_LANGUAGE_TO_LOOKER_LOCALE: Record<SupportedLanguage, LookerLocale> = {
  [SupportedLanguages.FRENCH]: LookerLocales.FRENCH,
  [SupportedLanguages.ENGLISH]: LookerLocales.ENGLISH,
};

export function useReportStore(storeId = 'reports') {
  const store = defineStore(storeId, {
    state: (): State => ({
      reportURL: null,
    }),
    actions: {
      async postLookerEmbedUrl(url: string, locale: SupportedLanguage) {
        const request = await this.cdlApi.post('/user/looker/embedurl', {
          url,
          locale: SUPPORTED_LANGUAGE_TO_LOOKER_LOCALE[locale],
        });

        this.reportURL = request.data.embed_url;
      },
    },
    getters: {
      canAccessReportsSection(): boolean {
        const authStore = useAuthStore();
        return authStore.hasPermissions([PermissionScope.reports]);
      },
    },
    pagination: false,
  });

  return store();
}
